/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react'
import { useThree } from '@react-three/fiber'
import { useTexture } from '@react-three/drei'
import { useDispatch } from 'react-redux'

import { const_var, params } from '../../../redux/reducers/reducer'
import { wallnameBySec, wallNameByStorageSec } from '../../../redux/reducers/building_component/componentReducer'
import { updateDoorWindowsArray } from '../../../action'

import { textureAnisotropy } from '../../../utils/Functions'
import { TrussRailTextureImg } from '../../../utils/Textures'

import FrontLean from './FrontLean'
import BackLean from './BackLean'
import LeftLean from './LeftLean'
import RightLean from './RightLean'
import GableLeftLean from './GableLean/LeftLean'
import GableRightLean from './GableLean/RightLean'
import GableFrontLean from './GableLean/FrontLean'
import GableBackLean from './GableLean/BackLean'

const LeanTo = () => {
    const dispatch = useDispatch();
    
    const { gl } = useThree();
    const [overlapTrussArr, setOverlapTrussArr] = useState(false);
    const texture = useTexture( process.env.REACT_APP_BASE_URL+TrussRailTextureImg);

    const envMap = useMemo(() => {
        let envMap = const_var.envIMG
        textureAnisotropy(gl, envMap, 1, 1, 0)
        return envMap
    }, []);
    
    const normalMap = useMemo(() => {
        let normalMap = texture
        textureAnisotropy(gl, normalMap, 1, 1, Math.PI / 2)
        return normalMap
    }, []);

    useEffect(() => {
        if (const_var.newDoorsArray?.length > 0) {
            const leanTypes = [
                { key: 'add_front_lean', types: ['frontlean', 'gableFrontLean'], styleKey: 'front' },
                { key: 'add_back_lean', types: ['backlean', 'gableBackLean'], styleKey: 'back' },
                { key: 'add_left_lean', types: ['leftlean', 'gableLeftLean'], styleKey: 'left' },
                { key: 'add_right_lean', types: ['rightlean', 'gableRightLean'], styleKey: 'right' },
            ];
    
            leanTypes.forEach(({ key, types, styleKey }) => {
                if (!params[key]) {
                    const doorArrOnLean = const_var.newDoorsArray.filter(item => 
                        types.includes(wallnameBySec[item.userData.wallName])
                    );
    
                    if (doorArrOnLean.length > 0) {
                        const newDoorArrOnLean = const_var.newDoorsArray.filter(item => 
                            !types.includes(wallnameBySec[item.userData.wallName])
                        );
                        dispatch(updateDoorWindowsArray(newDoorArrOnLean, true));
                    }
                } else if (styleKey) {
                    const sectionName = params.leanStyle[styleKey] === 'standard' ? types[1] : types[0];
                    const doorArrOnLean = const_var.newDoorsArray.filter(item => wallnameBySec[item.userData.wallName] === sectionName);
                    
                    if (doorArrOnLean.length > 0) {
                        const newDoorArrOnLean = const_var.newDoorsArray.filter(item => wallnameBySec[item.userData.wallName] !== sectionName);
                        dispatch(updateDoorWindowsArray(newDoorArrOnLean, true));
                    }
                }
            });
        }
    }, [
        params.add_front_lean, 
        params.add_back_lean, 
        params.add_left_lean, 
        params.add_right_lean, 
        params.leanStyle.front, 
        params.leanStyle.back, 
        params.leanStyle.left, 
        params.leanStyle.right
    ]);

    useEffect(() => {
        if (const_var.newDoorsArray.length > 0) {
            const storageTypes = [
                { key: 'add_storage_check_front', types: ['frontlean-storage', 'gable-front-lean-storage'] },
                { key: 'add_storage_check_back', types: ['backlean-storage', 'gable-back-lean-storage'] },
                { key: 'add_storage_check', types: ['leftlean-storage', 'gable-left-lean-storage'] },
                { key: 'add_storage_check_right', types: ['rightlean-storage', 'gable-right-lean-storage'] },
            ];

            storageTypes.forEach(({ key, types }) => {
                if (!params[key]) {
                    const doorArrOnLean = const_var.newDoorsArray.filter(item => 
                        types.includes(wallNameByStorageSec[item.userData.wallName])
                    );

                    if (doorArrOnLean.length > 0) {
                        const newDoorArrOnLean = const_var.newDoorsArray.filter(item => 
                            !types.includes(wallNameByStorageSec[item.userData.wallName])
                        );
                        dispatch(updateDoorWindowsArray(newDoorArrOnLean, true));
                    }
                }
            });
        }
    }, [ params.add_storage_check_front, params.add_storage_check_back, params.add_storage_check, params.add_storage_check_right ])
    
    return !params.isShowCenter && (
        <group name='lean'>
            {(const_var.DistanceArr!=undefined && const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) && 
                <>
                {params.add_left_lean && (
                        params.leanStyle.left === 'standard' ?
                            <LeftLean overlapTrussArr={overlapTrussArr} setOverlapTrussArr={setOverlapTrussArr} normalMap={normalMap} envMap={envMap} />
                            :
                            <GableLeftLean overlapTrussArr={overlapTrussArr} setOverlapTrussArr={setOverlapTrussArr} normalMap={normalMap} envMap={envMap} />
                    )}
                    {params.add_right_lean && (
                        params.leanStyle.right === 'standard' ?
                            <RightLean overlapTrussArr={overlapTrussArr} setOverlapTrussArr={setOverlapTrussArr} normalMap={normalMap} envMap={envMap} />
                            :
                            <GableRightLean overlapTrussArr={overlapTrussArr} setOverlapTrussArr={setOverlapTrussArr} normalMap={normalMap} envMap={envMap} />
                    )}
                    {params.add_front_lean && (
                        params.leanStyle.front === 'standard' ?
                            <FrontLean overlapTrussArr={overlapTrussArr} setOverlapTrussArr={setOverlapTrussArr} normalMap={normalMap} envMap={envMap} />
                            :
                            <GableFrontLean overlapTrussArr={overlapTrussArr} setOverlapTrussArr={setOverlapTrussArr} normalMap={normalMap} envMap={envMap} />
                    )}
                    {params.add_back_lean && (
                        params.leanStyle.back === 'standard' ?
                            <BackLean overlapTrussArr={overlapTrussArr} setOverlapTrussArr={setOverlapTrussArr} normalMap={normalMap} envMap={envMap} />
                            :
                            <GableBackLean overlapTrussArr={overlapTrussArr} setOverlapTrussArr={setOverlapTrussArr} normalMap={normalMap} envMap={envMap} />
                    )}
                </>
            }
        </group>
    )
}

export default LeanTo